import styled, { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const slideUp = keyframes`
  0% { transform: translateY(50px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
`;

export const slideIn = keyframes`
  0% { transform: translateX(100%); }
  100% { transform: translateX(0); }
`;

export const ChatOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
  z-index: 9990;
  animation: ${fadeIn} 0.2s ease forwards;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const ChatLayout = styled.div<{ isExpanded: boolean }>`
  position: fixed;
  bottom: 100px;
  right: 20px;
  z-index: 9999;
  width: ${({ isExpanded }) => (isExpanded ? '640px' : '400px')};
  height: ${({ isExpanded }) => (isExpanded ? 'max(658px, calc(var(--vh) - 150px))' : '658px')};
  max-height: 80vh;
  display: flex;
  gap: 12px;
  font-family: 'Helvetica Neue', sans-serif;
  animation: ${slideUp} 0.3s ease forwards;
  transition:
    width 0.4s ease,
    height 0.4s ease;

  @media (max-width: 768px) {
    top: 0;
    right: 0;
    width: 100%;
    height: var(--vh);
    height: 100dvh;
    max-height: var(--vh);
    max-height: 100dvh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    animation: ${slideIn} 0.3s ease forwards;
    flex-direction: column;
  }
`;

// Chat Window Container
export const ChatContainer = styled.div`
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  width: 100%;
  display: flex;
  border-radius: 12px;
  flex-direction: column;
  background: #fff;

  @media (max-width: 768px) {
    border-radius: 0;
    height: 100%;
    max-height: -webkit-fill-available; /* For iOS Safari */
    display: flex;
    flex-direction: column;
    overscroll-behavior: none;
  }
`;

// Header Section
export const ChatHeader = styled.div`
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  border-radius: 12px 12px 0 0;
  border-bottom: 1px solid #f0f0f0;
  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    border-radius: 0;
  }
`;

export const ChatTitle = styled.span`
  text-align: center;
  font-family: Lato;
  font-weight: 900;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.5px;
`;

export const ChatBody = styled.div`
  flex-grow: 1;
  padding: 12px;
  overflow-y: auto;
  background: #fff;
  overscroll-behavior: none;
`;

export const MessageBubble = styled.div<{ isUser?: boolean }>`
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
  flex-direction: ${(props) => (props.isUser ? 'row-reverse' : 'row')};
`;

export const Avatar = styled.div<{ isUser?: boolean }>`
  width: 32px;
  height: 32px;
  background: ${(props) => (props.isUser ? '#ccc' : 'url("assistant-avatar.png") center/cover no-repeat')};
  border-radius: 50%;
  margin: ${(props) => (props.isUser ? '0 0 0 8px' : '0 8px 0 0')};
`;

export const Bubble = styled.div<{ isUser?: boolean }>`
  background: ${(props) => (props.isUser ? '#e0e0e0' : '#ffe0b2')};
  color: #333;
  padding: 8px 12px;
  border-radius: 12px;
  max-width: 70%;
`;

export const ScrollSpacer = styled.div<{ height: number }>`
  height: ${(props) => props.height}px;
  transition: height 600ms ease;
  pointer-events: none;
`;
